import { httpClient } from '#app/api/httpClient';
import { Environment } from '#app/contexts/AppContext/AppContext';

/**
 * Get environment data from the server.
 */
export async function getEnvironmentData() {
  return await httpClient.get<Environment>('/api/environment');
}
